// Sentry must be the very first import
import "./sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import App from "./App";
import DemoGate from "./components/demo/DemoGate";
import { Sentry } from "./sentry";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

const SentryErrorBoundary = Sentry?.ErrorBoundary || (({ children }) => children);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={
      <div style={{ minHeight: "100dvh", background: "#06061a", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", flexDirection: "column", gap: 12, padding: 24 }}>
        <div style={{ fontSize: 48 }}>💥</div>
        <p style={{ fontWeight: 900, fontSize: 18 }}>Etwas ist schiefgelaufen</p>
        <p style={{ color: "#6b7280", fontSize: 13 }}>Der Fehler wurde automatisch gemeldet.</p>
        <button onClick={() => window.location.reload()} style={{ marginTop: 8, padding: "10px 24px", borderRadius: 12, background: "linear-gradient(90deg,#8b5cf6,#06b6d4)", color: "#fff", fontWeight: 900, border: "none", cursor: "pointer" }}>
          Neu laden
        </button>
      </div>
    }>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DemoGate>
          <App />
        </DemoGate>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: "#0d0d2b", color: "#fff", border: "1px solid rgba(139,92,246,0.3)", borderRadius: "12px", fontSize: "14px", fontWeight: 600 },
            success: { iconTheme: { primary: "#22c55e", secondary: "#0d0d2b" } },
            error:   { iconTheme: { primary: "#ef4444", secondary: "#0d0d2b" } },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
);
